import { BackgroundTypes } from '../../components/PersonalisedHeroBanner/PersonalisedHeroBanner.types'
import { Price } from '../types'

export const GET_PROMOTION = 'GET_PROMOTION'
export const GET_PROMOTION_SUCCESS = 'GET_PROMOTION_SUCCESS'
export const GET_PROMOTION_FAILURE = 'GET_PROMOTION_FAILURE'

export interface Promotion {
  voucherCode: string
  bannerTitle: string
  bannerDescription: string
  ctaButtonText: string
  ctaButtonUrl: string
  backgroundType?: BackgroundTypes
  backgroundHexCode: string
  imageUrl: string
  originalPrice: Price
  finalPrice: Price
  dataAllowanceGB: number
  dataAllowancePromosOnlyGB: number
}

export interface PromotionState {
  promotion: Promotion | null
  isFetching: boolean
  hasFetched: boolean
  errorMessage: string | null
}
